import React, { FunctionComponent, useState, useEffect } from 'react'
import Inputs, { InputsGroup, InputLabel, InputImage } from '../../Components/Inputs'

type FormPerfilProps = {
    item: any
    action: string
    errors: any
    handleOnChange: (e: any) => void
}

const FormPerfil: FunctionComponent<FormPerfilProps> = ({ item, action, errors, handleOnChange }) => {

    const [status, setStatus] = useState([])

    useEffect(() => {
        handleStatus()
    }, [])

    const handleStatus = () => {
        const statusList: any = [{ value: 1, text: "Activo" }, { value: 0, text: "Inactivo" }]
        setStatus(statusList)
    }

    const renderInputs = () => {
        if (action === "view") {
            return (
                <>

                </>
            )
        } else {
            return (
                <>
                    <InputsGroup>
                        <>
                            <Inputs
                                id={"descripcion"}
                                label={"Nombre"}
                                type={"text"}
                                value={item?.descripcion}
                                labelPercent={18}
                                handleOnChange={handleOnChange}
                                className={`input ${errors["descripcion"] ? "input_error" : ""}`}
                                errorMessage={errors["descripcion"]}
                                maxLength={50}
                            />
                            <Inputs
                                id={"idEstatus"}
                                label={"Estatus"}
                                type={"select"}
                                value={item?.idEstatus}
                                visible={!(action === "edit")}
                                handleOnChange={handleOnChange}
                                options={status}
                                className={`input ${errors["idEstatus"] ? "input_error" : ""}`}
                                errorMessage={errors["idEstatus"]}
                            />
                        </>
                    </InputsGroup>
                </>
            )
        }
    }

    return (
        <>
            {renderInputs()}
        </>
    )
}

export default FormPerfil